import { configureStore } from "@reduxjs/toolkit";
import { forgetPasswordSlice } from "./forget-password-slice";
import { onBoardingSlice } from "./on-boarding-slice";

const store = configureStore({
    reducer: {
        forgetPassword: forgetPasswordSlice.reducer,
        onBoarding: onBoardingSlice.reducer,
    }
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export default store